import BoardModel from '@/dex-shared/models/BoardModel';

export default {
  boardById: (state: any, getters: any) => (boardId: number) => {
    const board = state.boards[boardId];
    if (board) return new BoardModel(board, getters);
    return {};
  },
  allBoards: (state: any, getters: any) => {
    return Object.values(state.boards).map(
      (board: any) => new BoardModel(board, getters),
    );
  },
};
